import { lazy } from 'react'
import { useTranslation } from 'react-i18next'

import { CounterStyle } from 'features/globalSetup/api/types/counterStyle'

import type { SelectOption } from 'components/Select'

const HarveyBallIcon = lazy(() => import('images/icons/harvey-ball.svg?react'))
const ProgressBarIcon = lazy(() => import('images/icons/progress-bar.svg?react'))

export const useGetCounterStyles = (): SelectOption<CounterStyle>[] => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.richPlacements.multiAnchor.appearance.counterStyle.options',
  })

  return [
    {
      label: t('progressBar'),
      logo: ProgressBarIcon,
      value: 'progressBar',
    },
    {
      label: t('harveyBall'),
      logo: HarveyBallIcon,
      value: 'harveyBall',
    },
  ]
}
